// Write your code here

import './index.css'

const AppItem = props => {
  const {appDetails} = props
  const {appName, imageUrl} = appDetails

  return (
    <li className="app-item-bg">
      <img src={imageUrl} alt={appName} className="app-img" />
      <p className="appName">{appName}</p>
    </li>
  )
}

export default AppItem
